import alt from 'components/Dispatcher';
import CommentActions from 'actions/CommentActions';
import CommentSource from 'sources/CommentSource';

export class CommentStore {
  constructor() {
    this.state = {
      media_id: null,
      comments: [],
      first: 0,
      maxCount: 20,
      postComment: null
    }
    this.registerAsync(CommentSource);
    this.bindListeners({
      handleFetchComments: CommentActions.FETCH_COMMENTS,
      handleUpdateComments: CommentActions.UPDATE_COMMENTS,
      handlePostComment: CommentActions.POST_COMMENT,
      handleAddComment: CommentActions.ADD_COMMENT
    })
  }
  handleFetchComments(mid) {
    this.state.media_id = mid;
    this.getInstance().getRemoteComments();
  }
  handleUpdateComments(comments) {
    this.state.comments = comments;
  }
  handlePostComment(comment) {
    this.state.postComment = comment;
    this.state.media_id = comment.media_id;
    this.getInstance().postRemoteComment();
  }
  handleAddComment(comment) {
    this.state.comments.push(comment);
  }
}

export default alt.createStore(CommentStore, 'CommentStore');



// WEBPACK FOOTER //
// ./src/stores/CommentStore.js